import "./downloadApp.css"


const downloadApp = (props) => {


    const setLink =() => {

        
            // console.log('props', props.data.downloadButtons.items[0].cta)
            var oneLinkURL =  props.data.downloadButtons.items[0].cta
            var mediaSource = {keys:["utm_source"],defaultValue:"Discovery-Web"};
        
            var campaign = {keys:["utm_campaign"],defaultValue:"Discovery-Web"}; //default actual URL 
            var ad = {keys:["utm_content"],defaultValue:"(not%20set)"};
            var adSet = {keys:["utm_term"], defaultValue:"Discovery-Web"} 
            var channel = {keys:['utm_channel'], defaultValue:props.data.downloadButtons.items[0].currentURL} // check with client about parameterg
            var googleClickIdKey = "af_sub1";
            var custom_ss_ui = {paramKey:"af_ss_ui",defaultValue:"true"};
    
    
            var urlParams = new URLSearchParams(window.location.search);
            var utmCampaignValue = urlParams.get("utm_campaign");
    
            
            if (utmCampaignValue) {
              campaign.overrideValues =  {[utmCampaignValue.toString()]: utmCampaignValue.toString() + '_Discovery-Web'}//utmCampaignValue + "_Discovery-Web";
            }
          
            //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
            //Onelink URL is generated.
            
            var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
                oneLinkURL: oneLinkURL,
                afParameters: {
                    mediaSource: mediaSource,
                    campaign: campaign,
                    ad: ad,
                    channel: channel,
                    adSet: adSet,
                    googleClickIdKey: googleClickIdKey,
                    afCustom: [
                        custom_ss_ui
                    ]
                }
            });
    
            console.log('result smartLink',  result)
    
            if (result) {
              window.open(result.clickURL)
            }
    
      }
    

    

    return(
        <div className="">
            <button  onClick={setLink} className="download-main-btn">Descargar</button>
            {/* <div className="col-12 col-sm-8 col-md-12 text-center">
                {props.showTitle && <h2>{props.data.title}</h2>}
                <div className="app-btn-container d-flex justify-content-center  ">
                    <div className="row col-10 ">
                        {props.data.downloadButtons.items.map((item, index)=>{
                            return(
                                <div className="col-6  col-md-6  ">
                                    <a href={item.cta} target="_blank" rel="noreferrer">
                                        <img className="img-fluid" src={item.image} alt={item.alt_image}/>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div> */}
        </div>
    )
}


export default downloadApp;